import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'limitedChars',
})
export class LimitedCharsPipe implements PipeTransform {

  transform(value: string, maxNumberOfChars = 50): string {
    return value.substring(0, maxNumberOfChars);
  }

}
